var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0007 30.6667C24.1008 30.6667 30.6673 24.1002 30.6673 16C30.6673 7.89986 24.1008 1.33337 16.0007 1.33337C7.90047 1.33337 1.33398 7.89986 1.33398 16C1.33398 24.1002 7.90047 30.6667 16.0007 30.6667ZM22.2995 12.9196C22.8073 12.3863 22.7867 11.5424 22.2535 11.0345C21.7203 10.5267 20.8763 10.5473 20.3684 11.0805L13.767 18.012L11.6796 15.5768C11.2004 15.0177 10.3587 14.9529 9.79958 15.4321C9.24048 15.9114 9.17573 16.7531 9.65496 17.3122L12.7026 20.8678C12.948 21.154 13.3031 21.323 13.68 21.3329C14.0569 21.3428 14.4204 21.1926 14.6804 20.9196L22.2995 12.9196Z",
    fill: "#52D092"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/icon-checked.b958bc237c40c0de95478a77f4956886.svg";
export { ForwardRef as ReactComponent };